<!-- 

INPUT PARA EMAILS COM OPÇÃO PARA INFORMAR VÁRIOS EMAILS

-->

<template>
    <div class="form-control form-control-sm">
      <div class="row" v-if="emailList.length > 0" style="cursor: text" @click="focus">
          <div class="col-md-12">
              <div class="badge-email mr-2" :class="{ 'invalid': email.invalid }" role="alert" v-for="(email, index) in emailList" :key="index">
                  <button type="button" tabindex="1" class="close" data-dismiss="alert" @click="handleRemoveEmail(index)">
                      x</button>
                  <label class="mt-1">{{ email.label }}</label>
              </div>
          </div>
      </div>
      <input-search v-show="showInput" ref="email" v-model="email" :isEmailList="true" :params="inputParams" @select="handleSelect" @enter="addEmailDigitado" @blur="handleBlur">
      </input-search>
    </div>
</template>

<script>
import { SysVars } from '../main';

export default {
    props: {
      'url': String, 
      'emails': Array,
    },

    data () {
      return {
        email: this.value,
        fucused: false,

        emailList: [],
        //{ email: '', nome: '', label: '', invalid: false }

        inputParams: {
            url: this.url,
            permite_novo: false,
            codigo: null,
        },

        showInput: true,

      }
    },

    watch: {
      emails: function (newValue) {
        this.emailList = newValue
      }
    },

    methods: {

      handleBlur (text) {
        if (text)
          this.addEmailDigitado(text, true)
        this.$emit('blur')
        if (this.emailList.length > 0)
          this.showInput = false
      },

      addEmailDigitado (text, blur) {
        //ADICIONA UM EMAIL DIGITADO
        if (!text)
          return
        this.email = text
        if (this.email) {
          let email = {
            email: this.email, nome: '', label: this.email, invalid: !this.$isValidEmail(this.email) 
          }
          this.emailList.push(email)
          this.email = ''
          this.$nextTick(function () {
            if (!blur)
              this.$refs.email.focus()
            this.$refs.email.textSearch = null
          })
        }
        
      },

      handleSelect (selected) {
        if (selected) {
          let email = {
            email: selected.email,
            nome: selected.nome,
            label: selected.nome + ' (' + selected.email + ')'
          }
          this.email = ''
          this.emailList.push(email)
          this.$nextTick(function () {
            this.$refs.email.textSearch = null
            this.$refs.email.focus()
          })
        }
      },

      focus: function () {
        console.log('input-email-list')
          this.showInput = true
          this.$nextTick(function () {
            if (this.$refs.email) {
              this.$refs.email.focus()
            }
          })
      },

      isValid: function () {
        let invalid = this.emailList.filter((obj) => {
              return obj.invalid
        })
        
        if (invalid.length > 0)
          return false
        else 
          return true
      },

      handleRemoveEmail (index) {
        this.emailList.splice(index, 1)
      },

    },

    created () {
      if (this.emails)
        this.emailList = this.emails
    },

   
}
</script>



<style scoped>


.badge-email {
    display: inline-block;
    padding: 0 5px 0 5px;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    background: #fff;
    border: 1px solid;
    border-radius: 10px;
    border-color: #ebebeb;    
}

.badge-email:hover {
    background-color: #f7f7f7;
}

.invalid {
    border-color: red;    
}

.close:hover, .close:focus {
    /* color: #000; */
    text-decoration: none;
    opacity: .75;
}

.close {
    float: right;
    font-size: 1.0rem;
    color: #c5c4c4; 
    opacity: 1;
    margin: 3px 5px 0px 5px;
}

</style>


// WEBPACK FOOTER //
// src/components/input-email-list.vue